import * as type from '../types';

const initialState = {
  user: {
    // token: 'test',
    // roles: ['ADMIN'],
  },
};

export default function authorization(state = initialState, action) {
  switch (action.type) {
    case type.GET_USER:
      return {
        ...state,
        user: action.payload,
      };
    case type.SET_USER:
      return {
        user: action.payload,
      };
    default:
      return state;
  }
}
